import { IBindable, AggregationMode } from '../../models';

export class TableByGroupWidgetSeries implements IBindable {
    aggregationMode: AggregationMode;
    color: string;
    decimals: number;
    format: string;
    guid: string;
    isBoundToGroup: boolean;
    isUnitVisible: boolean;
    legend: string;
    name: string;
    originalGuid: string;
    relativePath: string;
    sortOrder: number;
    value: string;

    constructor(guid: string) {
        this.guid = guid;
        this.decimals = 2;
        this.value = 'average';
        this.aggregationMode = AggregationMode.None;
    }
}